export default "__VITE_ASSET__CJcWxKrU__"